<template>
  <div class="shipping-items">
    <b-table
      :items="shipping.itemsToShow"
      :fields="fields"
    >
      <template v-slot:cell(reference_code)="row">
        <h6 class="mb-0"><b-badge variant="dark">{{row.value}}</b-badge></h6>
      </template>
      <template v-slot:cell(description)="row">
        - {{row.item.description || 'No description'}}
      </template>
      <template v-slot:cell(quantity)="row">
        {{row.item.quantity || 1}} u.
      </template>
      <template v-slot:cell(serial_number)="row">
        <span v-if="row.item.original_serial_number && row.item.original_serial_number.length > 0">
          {{row.item.original_serial_number.join(', ')}}
        </span>
        <b-button size="sm" :disabled="shipping.status !== 'DELIVERED' && 1 === 0" variant="link" style="padding:0 .5rem" @click.prevent="itemEdit = row.item;" v-if="isSuperAdmin" v-b-modal.modalItemEdit><font-awesome-icon icon="edit" /></b-button>
      </template>
    </b-table>

    <b-modal id="modalItemEdit" ref="modalItemEdit" hide-footer @hide="itemEdit = {};">
      <template #modal-title>
        <translate>Edit Serial Numbers</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <form @submit.stop.prevent="patchItem">
        <div class="form-group col-sm-12">
          <div v-for="(serialNumber, i) in itemEdit.quantity" :key="i" class="mb-3">
            <label :for="'item-serial-' + i" v-translate="{original: itemEdit.original_serial_number[i] || '-'}">Original SN: %{original}</label>
            <b-form-input v-model="itemEdit.serial_number[i]"
              :id="'item-serial-' + i"
              type="text"
            ></b-form-input>
          </div>
        </div>
        <div class="form-group col-sm-12 mt-3">
          <b-button variant="primary" type="submit" v-translate>
            Edit
          </b-button>
          <b-button variant="secondary" @click.prevent="closeModal('modalItemEdit')" v-translate>
            Cancel
          </b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  emits: ['success'],
  name: 'ShippingItems',
  props: {
    shipping: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      itemEdit: {},
      fields: [
        {
          key: 'reference_code',
          label: this.$gettext('Reference Code')
        },
        {
          key: 'description',
          label: this.$gettext('Description')
        },
        {
          key: 'quantity',
          label: this.$gettext('Quantity')
        },
        {
          key: 'serial_number',
          label: this.$gettext('Serial Number')
        }
      ]
    }
  },
  watch: {
    itemEdit(val) {
      if (!val.serial_number) {
        this.itemEdit.serial_number = []
        this.itemEdit.original_serial_number = []
      }
    }
  },
  methods: {
    patchItem() {
      if (
        confirm(this.$gettext('Are you sure you want to EDIT the serial numbers of this shipping?\n\nWARNING: THIS ACTION CANNOT BE UNDONE!'))
      ) {
        const payload = {
          serial_number: this.itemEdit.serial_number.filter(Boolean)
        }
        payload.serial_number = payload.serial_number.length > 0 ? payload.serial_number : null
        this.$http.patch(this.$appConfig.api.baseUrl + 'shipping-items/' + this.itemEdit.id, payload)
          .then(response => {
            this.$emit('success', true)
            this.$root.$emit('bv::refresh::table', 'shippings')
            this.closeModal('modalItemEdit')
          })
      }
    }
  }
}
</script>
